import React, { useContext } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

import { useHistory } from "react-router-dom";

//material ui
import { PrimaryButton } from "../../materialUiComponents";

const WelcomeMessage = () => {
  //consume global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  const history = useHistory();

  const goToPage = (path) => {
    setState({ ...state, currentModule: "query" });
    history.push(path);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <h3
        style={{
          fontFamily: "'Alegreya Sans', sans-serif",
          fontSize: "36px",
          textAlign: "center",
          marginBottom: "10px",
          color: state.theme === "dark" ? "#fff" : "#00152b",
        }}
      >
        Weaviate Console
      </h3>
      <PrimaryButton onClick={() => goToPage("/console/query")}>Query module</PrimaryButton>
    </div>
  );
};

export default WelcomeMessage;
